import { publicConfig } from "@/PublicConfig";

interface CreateEmailCheckOptions {
  payload: {};
}

export const createEmailCheck = async (options: CreateEmailCheckOptions) => {
  const url = new URL(publicConfig.accountServiceEndpointURL);

  url.pathname = "/user-exists";

  const response = await fetch(url, {
    body: JSON.stringify(options.payload),
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
  });

  if (!response.ok) {
    throw await response.json();
  }

  return await response.json();
};
